/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { ErrorDetail } from './ErrorDetail';

export const ProblemBlobNotFound: core.serialization.ObjectSchema<
    serializers.ProblemBlobNotFound.Raw,
    Truvity.ProblemBlobNotFound
> = core.serialization.object({
    detail: core.serialization.string().optional(),
    errors: core.serialization.list(ErrorDetail).optional(),
    id: core.serialization.string(),
    instance: core.serialization.string().optional(),
    kind: core.serialization.string(),
    status: core.serialization.number(),
    title: core.serialization.string(),
});

export declare namespace ProblemBlobNotFound {
    export interface Raw {
        detail?: string | null;
        errors?: ErrorDetail.Raw[] | null;
        id: string;
        instance?: string | null;
        kind: string;
        status: number;
        title: string;
    }
}
